module.exports = __webpack_public_path__ + "static/media/icon-status-complete.67ccdea6.svg";